/**
 * Cloud Glaze featured collection — wishlist + card polish
 */
(() => {
  const STORAGE_KEY = 'ct-wishlist-handles';

  /** @returns {Set<string>} */
  const readWishlist = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const list = raw ? JSON.parse(raw) : [];
      return new Set(Array.isArray(list) ? list.map(String) : []);
    } catch {
      return new Set();
    }
  };

  /** @param {Set<string>} set */
  const writeWishlist = (set) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
    } catch {
      /* private mode */
    }
  };

  /** @param {HTMLElement} root */
  const syncButtons = (root, set) => {
    root.querySelectorAll('[data-ct-cgc-wishlist]').forEach((btn) => {
      if (!(btn instanceof HTMLButtonElement)) return;
      const handle = btn.dataset.productHandle || '';
      const on = handle !== '' && set.has(handle);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
    });
  };

  /** @param {HTMLElement} root */
  const bind = (root) => {
    if (root.dataset.ctCgcReady === 'true') return;
    root.dataset.ctCgcReady = 'true';

    const set = readWishlist();
    syncButtons(root, set);

    root.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const btn = target.closest('[data-ct-cgc-wishlist]');
      if (!(btn instanceof HTMLButtonElement) || !root.contains(btn)) return;

      event.preventDefault();
      event.stopPropagation();

      const handle = btn.dataset.productHandle || '';
      if (!handle) return;

      if (set.has(handle)) set.delete(handle);
      else set.add(handle);

      writeWishlist(set);
      syncButtons(root, set);
      window.dispatchEvent(
        new CustomEvent('ct:wishlist-change', {
          detail: { handle, active: set.has(handle), handles: [...set] },
        })
      );
    });
  };

  const init = () => {
    document.querySelectorAll('[data-ct-cgc]').forEach((el) => {
      if (el instanceof HTMLElement) bind(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
